module.exports = __webpack_public_path__ + "img/Anhänger_TWAA.b75f9756.svg";